import { Controller } from "@hotwired/stimulus"

// Submits the form associated with the changed control, including controls
// linked to an external form via the HTML form="" attribute.
export default class extends Controller {
  submit(event) {
    event.target.form?.requestSubmit()
  }
}
